import React, { useState, useEffect, useRef, useMemo } from 'react';
import Fade from 'react-bootstrap/Fade';
import API from '../../../utils/API';
import { Link } from 'react-router';
import { useAuth } from '../../../utils/Auth';
import styles from './Inbox.module.css';

export default function Inbox() {

    const { messageObj } = useAuth();
    const [ open, setOpen ] = useState('');
    const menuRef = useRef();

    const messages = useMemo(() => {
        if (messageObj) {
            return Object.values(messageObj).filter(obj => obj.deleted === 0 && obj.type === 'message').sort((a, b) => a.read === b.read ? 0 : a.read ? 1 : -1);
        }
        return [];
    }, [messageObj]);

    const handleDeleteThread = async(e, key) => {
        e.stopPropagation();
        try {
            await API.deleteMessage({ arr: [key] });
        } catch (err) {
            console.error(err);
        };
    };

    const handleInboxMenu = (e, key) => {
        e.stopPropagation();
        if (open && open === key) {
            setOpen('');
        } else {
            setOpen(key);
        };
    };

    useEffect(() => {
        const handleClickOutside = e => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setOpen(false);
            };
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    },[]);
    
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.headerInner}>
                    <div className={styles.title}>Inbox</div>
                    <div className={styles.subtitle}>Stay in touch!</div>
                </div>
                <div className={styles.notifications}>
                    <i className='fa-light fa-inbox' />
                    {messages?.filter(message => message.read === false).length > 0 ? <div style={messages.filter(message => message.read === false).length > 1 ? {fontSize: '.7rem'} : null}>{messages.filter(message => message.read === false).length}</div> : <></>}
                </div>
            </div>
            <div className={styles.list}>
                {messages.length > 0 ? messages.map((message, i) => (
                    <div className={styles.message} key={message.timestamp + i}>
                        <div className={styles.messageLeft}>
                            <div className={styles.messageRead}>{message.read ? <i className='far fa-circle' /> : <i className='fas fa-circle' />}</div>
                            <span className={styles.messageInner} style={!message.read ? {fontWeight: '600'} : null}>
                                <div className={styles.messageFrom}><span>From:</span> {message.email}</div>
                                <div className={styles.messageContent}>{message.message}</div>
                            </span>
                        </div>
                        <div className={styles.messageButtons}>
                            {/* reply */}
                            <Link className={styles.messageBtn} onClick={e => e.stopPropagation()} to='/inbox'  state={{ userToMessage: '', thread: message.key, type: 'reply' }} title='Reply'><i className='far fa-reply' /></Link>
                            {/* delete */}
                            <button className={styles.messageBtn} title='Delete' onClick={e => handleDeleteThread(e, message.key)}><i className='far fa-trash-can' /></button>
                        </div>
                        <div className={styles.messageButtons992}>
                            <button className={styles.inboxMenuBtn} onClick={e => handleInboxMenu(e, message.key)}><i className='fas fa-ellipsis-vertical' /></button>
                            <Fade in={open === message.key} style={open === message.key ? {display: 'flex'} : {display: 'none'}}>
                                <div className={styles.inboxMenuPosition} ref={menuRef}>
                                    <div className={styles.inboxMenu}>
                                    <Link className={styles.inboxMenuOption} onClick={e => e.stopPropagation()} to='/inbox' state={{ userToMessage: '', thread: message.key, type: 'reply' }} title="Reply"><i className='far fa-reply' />Reply</Link>
                                        <button className={styles.inboxMenuOption} title="Delete" onClick={e => {handleDeleteThread(e, message.key); setOpen('');}}><i className='far fa-trash-can' /> Delete</button>
                                    </div>
                                </div>
                            </Fade>
                        </div>
                    </div>
                ))
                :
                <>
                <div className={styles.messageFake}>
                    <div className={styles.messageLeft}>
                        <div className={styles.messageRead}><i className='fas fa-circle' /></div>
                        <span className={styles.messageInner}>
                            <div className={styles.messageFrom}><span>From:</span>email@email.com</div>
                            <div className={styles.messageContent}>Lorem ipsum...</div>
                        </span>
                    </div>
                    <div className={styles.messageButtons}>
                        <div className={styles.messageBtn} title='Reply'><i className='far fa-reply' /></div>
                        <div className={styles.messageBtn} title='Delete'><i className='far fa-trash-can' /></div>
                    </div>
                    <div className={styles.messageButtons992}>
                        <div className={styles.inboxMenuBtn}><i className='fas fa-ellipsis-vertical' /></div>
                    </div>
                </div>
                <div className={styles.noMessages}>You have no messages.</div>
                </>
                }
            </div>
        </div>
    );
};